import React from 'react';

export default (props) => (
  <footer className='main-footer rodape-copyright'> 
    <strong> 
      Copyright &copy; 2018
      <a className="a" href={props.link} target='_blank' rel="noopener noreferrer">
        {' ' + props.titulo} ®
      </a>.
    </strong>
  </footer>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/footer/Footer.jsx